import PSE from '@/pages/Pse/Index.vue'

export default [
  {
    path: '/pse',
    component: PSE
  }
]
